import styled from 'styled-components';

import { getFixedSpace, mq, getSpace } from '@stylesheets/tools';

const StyledActionBar = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;

  padding: ${getFixedSpace('xxxs')};

  ${mq('s')} {
    padding: ${getFixedSpace('xs')};
  }

  ${mq('m')} {
    flex-direction: row;
  }

  ${mq('xl')} {
    padding: ${getFixedSpace('xs')} ${getFixedSpace('m')};
  }

  .actionBar__wishes-count,
  .actionBar__actions {
    padding: 15px;

    ${mq('m')} {
      padding: 0 25px;
    }
  }

  .actionBar__actions {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: ${getSpace('xxxxs')};
    width: 100%;
    justify-content: space-between;

    ${mq('s')} {
      gap: ${getSpace('xxxs')};
      width: auto;
    }
  }

  .actionBar__wishes-count {
    text-align: center;

    ${mq('m')} {
      text-align: left;
    }
  }

  .actionBar__animation-toggle {
    width: 30px;

    ${mq('m')} {
      width: 42px;
    }
  }
`;

export default StyledActionBar;
